<template>
    <div id="driver_commissions" class="x_scrollable">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>

        <Filters>
        </Filters>

        <div class="ui segment">
            <div v-if="style.width < 767" style="margin-bottom: 1em;">
                <div v-if="is_loading">
                    <div class="ui active centered inline loader"></div>
                </div>
                <DataCard
                    v-else
                    v-for="driver_commission in driver_commissions"
                    :key="driver_commission.identity"
                    :object="driver_commission"
                    :title="driver_commission.staff ? driver_commission.staff.name : '-'"
                    :date="human_datetime(driver_commission.created_at)"
                    :sub_title="data_card_sub_title(driver_commission)"
                    :is_show_column="true"
                    :keys="['core_waybill_number']"
                    :i_18n_key="'driver_commissions'"
                >
                    <span slot="core_waybill_number">
                        <router-link
                            v-if="driver_commission.core_waybill"
                            :to="{
                                name: 'edit_core_waybill',
                                params: {identity: driver_commission.core_waybill.identity}
                            }">
                            {{ driver_commission.core_waybill.number }}
                        </router-link>
                        <span v-else>
                            -
                        </span>
                    </span>
                </DataCard>

                <div v-if="!is_loading && driver_commissions.length <= 0"
                    class="ui center aligned red segment">
                    <h3>
                        {{ $t('ui.general.no_data') }}
                    </h3>
                </div>
            </div>
            <table v-else class="ui compact celled table">
                <thead class="center aligned">
                    <tr>
                        <th>{{ $t('ui.pages.driver_commissions.driver') }}</th>
                        <th>{{ $t('ui.pages.driver_commissions.core_waybill_number') }}</th>
                        <th>{{ $t('models.attributes.driver_commissions.amount') }}</th>
                        <th>{{ $t('models.attributes.driver_commissions.created_at') }}</th>
                    </tr>
                </thead>
                <tbody v-if="is_loading" class="center aligned">
                    <tr class="loading">
                        <td colspan="4">
                            <div class="ui active centered inline loader"></div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else class="center aligned">
                    <DriverCommission
                        v-for="driver_commission in driver_commissions"
                        :key="driver_commission.identity"
                        :driver_commission="driver_commission">
                    </DriverCommission>
                    <tr v-if="driver_commissions.length <= 0" class="center aligned">
                        <td colspan="4" >
                            <h5>{{ $t('ui.general.no_data') }}</h5>
                        </td>
                    </tr>
                </tbody>
            </table>

            <Paginator
                :total_pages="pagination.total_pages"
                :current_page="pagination.current_page"
                :disabled="is_loading"
                >
            </Paginator>
        </div>
    </div>
</template>

<script>
import Filters from './filter/main.vue'
import DataCard from '@toolbox/data_card/main.vue'
import DriverCommission from "./index/driver_commission.vue"
import Paginator from '@toolbox/pagination/paginator.vue'
import ErrorMessages from '@toolbox/error_box/main.vue'

export default {
    name: "DriverCommissionsIndex",
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            errors: [],
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        current_store() {
            return this.$store.state.provider.driver_commissions_module
        },
        driver_commissions() {
            return this.current_store.driver_commissions
        },
        pagination() {
            return this.current_store.pagination
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
        this.init()
    },
    watch: {
        '$route'(to, from) {
            this.init(false)
        },
    },
    methods: {
        async init(is_first = true) {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    this.is_loading = true
                    resolve()
                })
                await this.$store.dispatch('provider/driver_commissions_module/handle_query_to_filter',{
                    query: this.$route.query
                })
                if (is_first) {
                    await this.$store.dispatch('provider/driver_commissions_module/handle_quick_filter_key')
                }
                await this.$store.dispatch('provider/driver_commissions_module/fetch_driver_commissions')
                await new Promise(resolve => {
                    this.$noty.information(
                        this.$t("ui.page_titles.driver_commissions") + ' ' +
                        this.$t('ui.general.initialize_complete')
                    , 300)
                    resolve()
                })
            } catch (e) {
                console.log(e)
                this.error.push(e)
                this.$noty.error(
                    this.$t('ui.notifications.error.fetch__name', {
                        name: this.$t('models.driver_commissions'),
                        reason: e
                    })
                )
            } finally {
                this.is_initialized = true
                this.is_loading = false
            }
        },
        driver_commissions_filter() {
            console.log('driver_commissions_filter')
            try {
                this.$router.push({
                    name: this.$router.name,
                    query: this.$store.getters['provider/driver_commissions_module/filter_to_query'],
                })
            } catch (e) {
                console.log(e)
            }
        },
        data_card_sub_title(driver_commission) {
            if (driver_commission.driver_commission_report_identity) {
                let icon = driver_commission.polarity == false ? `<i class="minus icon"></i>` : ``
                return `<span>
                    ${icon}
                    ${driver_commission.amount}
                </span>`
            } else {
                return this.$t('ui.pages.driver_commissions.no_done')
            }
        }
    },
    components: {
        DriverCommission,
        ErrorMessages,
        Paginator,
        DataCard,
        Filters,
    }
}
</script>

<style scoped lang="scss">
    #driver_commissions {
        & {
            overflow-x: auto;
        }
    }
    .th_dropdown {
        & {
            position: relative;
        }
        span.clear_dropdown {
            position: absolute;
            color: #4c4c4c;
            right: -9px;
            top: -9px;
        }
    }
</style>
